import React from 'react';
import type { SelectProps } from 'antd/lib/select';

import { userApi } from '../../lib/api';

import AutocompleteSelect from './AutocompleteSelect';
import type { User } from '../../lib/types';

type Props = SelectProps & {
  showFio?: boolean;
};

export default function UserSelect({ showFio, ...props }: Props) {
  return (
    <AutocompleteSelect<User>
      placeholder="Выберите пользователя"
      fetch={userApi.fetchUsers}
      fetchSingle={userApi.fetchUser}
      notFoundText="Пользователи не найдены"
      renderOption={(user, Option) => (
        <Option value={user.id} key={user.id} user={user}>
          {showFio
            ? `${user.employee.lastname} ${user.employee.firstname} ${
                user.employee.middlename
              }`
            : user.userName}
        </Option>
      )}
      {...props}
    />
  );
}
